import { createFileRoute, redirect } from '@tanstack/react-router'

import { AppShell } from '#/app/shell/app-shell'
import { isAuthenticated } from '#/modules/auth'

export const Route = createFileRoute('/_shell')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: AppShell,
})
